import React from 'react';
import type { DataTableRowEventHandler, RepeatRowsPayload } from '@/components/custom/erp';
import type { PhieuNhapDieuChuyenChiTiet } from '@/types/schemas';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { copyCellValue } from '@/lib/table-handlers';
import { getDetailTableColumns } from './columns';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
  rows: PhieuNhapDieuChuyenChiTiet[];
  selectedRowUuid?: string;
  onAddRow?: () => void;
  onDeleteRow?: () => void;
  onCopyRow?: () => void;
  onPasteRow?: () => void;
  onMoveRow?: (direction: 'up' | 'down') => void;
  onRepeatForRows?: (payload: RepeatRowsPayload<PhieuNhapDieuChuyenChiTiet>) => void;
  onRowClick?: DataTableRowEventHandler<PhieuNhapDieuChuyenChiTiet>;
  handleExport?: () => void;
  handlePin?: () => void;
}

export const DetailTab = ({
  formMode,
  rows,
  selectedRowUuid,
  onRowClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  handleExport,
  handlePin,
  onRepeatForRows
}: DetailTabProps) => {
  const actions = {
    ...(onAddRow ? { add: onAddRow } : {}),
    ...(onDeleteRow ? { delete: onDeleteRow } : {}),
    ...(onCopyRow ? { copy: onCopyRow } : {}),
    ...(onPasteRow ? { paste: onPasteRow } : {}),
    ...(onMoveRow ? { moveUp: () => onMoveRow('up') } : {}),
    ...(onMoveRow ? { moveDown: () => onMoveRow('down') } : {}),
    ...(handleExport ? { export: handleExport } : {}),
    ...(handlePin ? { pin: handlePin } : {})
  };

  return (
    <ErpInputTableV2
      rows={rows}
      autoHeight
      bottomSelector='[data-arito-bottom-bar]'
      columns={getDetailTableColumns()}
      selectedRowId={selectedRowUuid}
      onRowClick={onRowClick}
      enableContextMenu={true}
      onCopyData={({ columnValue, columnField, columnValues }) => {
        copyCellValue({
          columnField,
          columnValue,
          columnValues,
          fallback: text => {
            console.log('Copy data per column:', text);
          }
        });
      }}
      onRepeatForRows={onRepeatForRows}
      actions={actions}
      actionsDisabled={formMode === 'view'}
    />
  );
};
